import { MenuItemType } from 'types';
import {
  Warehouse,
  Wallet,
  Kanban,
  // FileText,
  UsersThree,
  Bell,
  House,
  Cardholder,
  GearSix,
  ProjectorScreenChart,
  FileMinus,
  // KeyReturn,
  Ranking,
  Tag,
  Gradient,
  User,
  AddressBook,
} from '@phosphor-icons/react';
import envService, { HiddenFeatures } from 'services/env.service';
import { PERMISSIONS } from './permission';

export const sidebarItems: MenuItemType = {
  key: 'setting',
  label: 'Quản Lý Cài Đặt',
  path: '/settings',
  icon: <Warehouse size={20} />,
  children: [
    {
      key: 'quanLyDanhMuc',
      label: 'Quản Lý Danh Mục',
      path: '/settings/categories',
      icon: <House size={16} />,
      permission: PERMISSIONS.CATEGORY,
    },
    {
      key: 'quanLyThuongHieu',
      label: 'Quản Lý Thương Hiệu',
      path: '/settings/brands',
      icon: <Cardholder size={16} />,
      permission: PERMISSIONS.BRAND,
    },
    {
      key: 'quanLyDonVi',
      label: 'Quản Lý Đơn Vị',
      path: '/settings/units',
      icon: <Warehouse size={16} />,
      permission: PERMISSIONS.UNIT,
    },
    {
      key: 'quanLyThuocTinh',
      label: 'Quản Lý Thuộc Tính',
      path: '/settings/attributes',
      icon: <ProjectorScreenChart size={16} />,
      permission: PERMISSIONS.ATTRIBUTE,
    },
    {
      key: 'quanLyNhanVien',
      label: 'Quản Lý Nhân Viên',
      path: '/settings/staff',
      icon: <User size={16} />,
      permission: PERMISSIONS.STAFF,
    },
    {
      key: 'quanLyNguyenLieu',
      label: 'Quản Lý Nguyên Liệu',
      path: '/settings/materials',
      icon: <Gradient size={16} />,
      permission: PERMISSIONS.MATERIAL,
    },
    {
      key: 'quanLyMaGiamGia',
      label: 'Quản Lý Mã Giảm Giá',
      path: '/settings/discount-codes',
      icon: <Tag size={16} />,
      permission: PERMISSIONS.DISCOUNT_CODE,
    },
    {
      key: 'quanLyHangThanhVien',
      label: 'Quản Lý Hạng Thành Viên',
      path: '/settings/member-ranks',
      icon: <Ranking size={16} />,
      permission: PERMISSIONS.MEMBER_RANK,
    },
    {
      key: 'phanQuyenHeThong',
      label: 'Phân Quyền Hệ Thống',
      path: '/settings/system-permissions',
      icon: <AddressBook size={16} />,
      permission: PERMISSIONS.PERMISSION,
    },

    {
      key: 'thongTinCongTy',
      label: 'Thông Tin Công Ty',
      path: '/settings/company-profile',
      icon: <FileMinus size={16} />,
      permission: PERMISSIONS.COMPANY_PROFILE,
    },
  ],
};
export const sidebarItemsConst: MenuItemType[] = [
  {
    key: 'thongBao',
    label: 'Thông Báo',
    path: '/notifications',
    icon: <Bell size={16} />,
  },
  {
    key: 'caiDat',
    label: 'Cài Đặt',
    path: '/general-settings',
    icon: <GearSix size={16} />,
  },
];

export const menuItems: MenuItemType[] = [
  {
    key: 'trangchu',
    label: 'Trang chủ',
    path: '/dashboard',
    permission: PERMISSIONS.DASHBOARD,
  },
  {
    key: 'hanghoa',
    label: 'Hàng hoá',
    icon: <Kanban size={20} />,
    path: '/items',
    permission: PERMISSIONS.PRODUCT,
    children: [
      {
        key: 'sanpham',
        label: 'Quản Lý Sản Phẩm',
        path: '/items/products',
        permission: PERMISSIONS.PRODUCT,
        children: [
          {
            key: 'createProduct',
            label: 'Tạo Sản Phẩm Mới',
            path: '/items/products/create-product',
            permission: PERMISSIONS.PRODUCT_CREATE,
          },
          {
            key: 'createProduct',
            label: 'Chi tiết sản phẩm',
            path: '/items/products/detail-product',
            subMenuDisplay: false,
            permission: PERMISSIONS.PRODUCT_CREATE,
          },
          {
            key: 'detailProduct',
            label: 'Danh sách sản phẩm',
            path: '/items/products',
            permission: PERMISSIONS.PRODUCT,
          },
        ],
      },
    ],
  },
  {
    key: 'quanly',
    path: '/management',
    icon: <Kanban size={20} />,
    label: 'Quản Lý',
    children: [
      {
        key: 'quanLyKho',
        label: 'Quản Lý Kho',
        path: '/management/inventory',
        icon: <Warehouse size={20} />,
        hasPage: false,
        permission: PERMISSIONS.WAREHOUSE,
        children: [
          {
            key: 'phieuKiemKho',
            label: 'Phiếu Kiểm Kho',
            path: '/management/inventory/check-orders',
            permission: PERMISSIONS.WAREHOUSE,
            children: [
              {
                key: 'createCheckOrder',
                label: 'Tạo Phiếu Kiểm Kho',
                path: '/management/inventory/check-orders/create',
                subMenuDisplay: false,
                permission: PERMISSIONS.WAREHOUSE_CREATE,
              },
              {
                key: 'detailCheckOrder',
                label: 'Chi Tiết ',
                path: '/management/inventory/check-orders/detail/:id',
                subMenuDisplay: false,
                permission: PERMISSIONS.WAREHOUSE_CREATE,
              },
            ],
          },
          {
            key: 'phieuXuatKho',
            label: 'Phiếu Xuất Kho',
            path: '/management/inventory/out-orders',
            permission: PERMISSIONS.STOCK_OUT_ORDER,
            children: [
              {
                key: 'createStockOutOrder',
                label: 'Tạo Phiếu Xuất Kho',
                path: '/management/inventory/out-orders/create',
                subMenuDisplay: false,
                permission: PERMISSIONS.STOCK_OUT_ORDER_CREATE,
              },
            ],
          },
          {
            key: 'phieuNhapHang',
            label: 'Phiếu Nhập Hàng',
            path: '/management/inventory/purchase-orders',
            permission: PERMISSIONS.PURCHASE_ORDER,
            children: [
              {
                key: 'dangNhapHang',
                label: 'Đang Nhập Hàng',
                path: '/management/inventory/purchase-orders/importing',
                subMenuDisplay: false,
              },
              {
                key: 'taoPhieuNhapHang',
                label: 'Tạo Phiếu Nhập Hàng',
                path: '/management/inventory/purchase-orders/create/:supplierId',
                subMenuDisplay: false,
                permission: PERMISSIONS.PURCHASE_ORDER_CREATE,
              },
            ],
          },
          {
            key: 'phieuTraHang',
            label: 'Phiếu Trả Hàng',
            path: '/management/inventory/return-orders',
            permission: PERMISSIONS.RETURN_PURCHASE,
            children: [
              {
                key: 'createReturnOrder',
                label: 'Tạo Phiếu Trả Hàng',
                path: '/management/inventory/return-orders/create',
                subMenuDisplay: false,
                permission: PERMISSIONS.RETURN_PURCHASE_CREATE,
              },
              {
                key: 'detailReturnOrder',
                label: 'Chi Tiết',
                path: '/management/inventory/return-orders/detail/:id',
                subMenuDisplay: false,
                permission: PERMISSIONS.RETURN_PURCHASE_CREATE,
              },
            ],
          },
          {
            key: 'supplierOrders',
            label: 'Đơn Hàng Nhà Cung Cấp',
            path: '/management/inventory/supplier-orders',
            permission: PERMISSIONS.ORDER_SUPPLIER,
            children: [
              {
                key: 'createSupplierOrder',
                label: 'Tạo Đơn Hàng Nhà Cung Cấp',
                path: '/management/inventory/supplier-orders/create/:id',
                subMenuDisplay: false,
                permission: PERMISSIONS.ORDER_SUPPLIER_CREATE,
              },
              {
                key: 'editSupplierOrder',
                label: 'Cập Nhập Đơn Hàng Nhà Cung Cấp',
                path: '/management/inventory/supplier-orders/edit/id',
                subMenuDisplay: false,
                permission: PERMISSIONS.ORDER_SUPPLIER_UPDATE,
              },
              {
                key: 'viewSupplierOrder',
                label: 'Chi Tiết Đơn Hàng Nhà Cung Cấp',
                path: '/management/inventory/supplier-orders/view/:id',
                subMenuDisplay: false,
                permission: PERMISSIONS.ORDER_SUPPLIER_CREATE,
              },
              {
                key: 'PayMentWaitSupplierOrder',
                label: 'Xác Nhận Thanh Toán',
                path: '/management/inventory/supplier-orders/payment-wait/:id',
                subMenuDisplay: false,
                permission: PERMISSIONS.ORDER_SUPPLIER_UPDATE,
              },
            ],
          },
        ],
      },
      // {
      //   key: 'quanLyBanHang',
      //   label: 'Quản Lý Bán Hàng',
      //   path: '/management/sales',
      //   icon: <Kanban size={20} />,
      //   children: [
      //     { key: 'donHang', label: 'Đơn Hàng', path: '/management/sales/orders' },
      //     { key: 'trangThai', label: 'Trạng Thái', path: '/management/sales/status' },
      //   ],
      // },
      {
        key: 'quanLyTaiChinh',
        label: 'Quản Lý Công Nợ',
        path: '/management/debts',
        icon: <Wallet size={20} />,
        permission: PERMISSIONS.DEBT,
      },
      {
        key: 'quanLyDonHang',
        label: 'Quản Lý Đơn Hàng',
        path: '/management/sale-orders',
        icon: <FileMinus size={20} />,
        permission: PERMISSIONS.SALE_ORDER,
        children: [
          {
            key: 'detailSaleOrder',
            label: 'Chi Tiết',
            path: '/management/sale-orders/detail',
            subMenuDisplay: false,
            permission: PERMISSIONS.SALE_ORDER_CREATE,
          },
        ],
      },
      {
        key: 'quanLyKhachHang',
        label: 'Quản Lý Khách Hàng',
        path: '/management/customers',
        icon: <UsersThree size={20} />,
        permission: PERMISSIONS.CUSTOMER,
        children: [
          {
            key: 'taomoikhachang',
            label: 'Tạo mới khách hàng',
            path: '/management/customers/create',
            permission: PERMISSIONS.CUSTOMER_CREATE,
          },
          {
            key: 'danhsachkhachang',
            label: 'Thông tin khách hàng',
            path: '/management/customers/tabs/:id',
            subMenuDisplay: false,
            permission: PERMISSIONS.CUSTOMER_CREATE,
          },
          {
            key: 'danhsachkhachang',
            label: 'Danh Sách Khách Hàng',
            path: '/management/customers',
            permission: PERMISSIONS.CUSTOMER,
          },
        ],
      },
      {
        label: 'Quản lý nhà cung cấp',
        key: 'supplier-management',
        path: '/management/suppliers',
        icon: <UsersThree size={20} />,
        permission: PERMISSIONS.SUPPLIER,
        children: [
          {
            label: 'Tạo nhà cung cấp',
            key: 'create-supplier',
            path: '/management/suppliers/create',
            permission: PERMISSIONS.SUPPLIER_CREATE,
          },
          {
            label: 'Danh Sách nhà cung cấp',
            key: 'supplier-list',
            path: '/management/suppliers',
            permission: PERMISSIONS.SUPPLIER,
          },
        ],
      },
      // {
      //   key: 'quanlytrahang',
      //   label: 'Quản lý trả hàng nhập',
      //   path: '/management/returnorder',
      //   icon: <KeyReturn size={20} />,
      //   children: [
      //     {
      //       label: 'Danh sách trả hàng nhập',
      //       key: 'order-list',
      //       path: '/management/returnorder',
      //     },
      //   ],
      // },
    ],
  },
  {
    key: 'hoadond',
    label: 'Hoá Đơn Điện Tử',
    icon: <Kanban size={20} />,
    path: '/invoices',
    isHide: envService.isFeatureHidden(HiddenFeatures.EInvoice),
    permission: PERMISSIONS.E_INVOICE,
    children: [
      {
        key: 'hoaDonDienTu',
        label: 'Quản Lý Hoá Đơn Điện Tử',
        path: '/invoices/electronic-invoices',
        permission: PERMISSIONS.E_INVOICE,
        children: [
          // {
          //   key: 'createInvoice',
          //   label: 'Tạo Hoá Đơn Điện Tử',
          //   path: '/invoices/electronic-invoices/create-invoice',
          //   permission: PERMISSIONS.E_INVOICE_CREATE,
          // },
          {
            key: 'listInvoice',
            label: 'Danh Sách Hoá Đơn Điện Tử',
            path: '/invoices/electronic-invoices',
            permission: PERMISSIONS.E_INVOICE,
          },
          {
            key: 'invoice04',
            label: 'Mẫu 04/SS-HDDT',
            path: '/invoices/...',
            permission: PERMISSIONS.E_INVOICE,
          },
        ],
      },
      {
        key: 'soKeToan',
        label: 'Sổ Kế Toán',
        path: '/accounting',
        children: [
          {
            key: 's2a',
            label: 'Sổ Doanh Thu',
            path: '/accounting/s2a',
            permission: PERMISSIONS.TRANSACTION,
          },
          // {
          //   key: 's2b',
          //   label: 'Sổ Doanh Thu',
          //   path: '/accounting/s2b',
          //   // permission: PERMISSIONS.ACCOUNTING_READ,
          // },
          {
            key: 's2d',
            label: 'Sổ Hàng Hoá',
            path: '/accounting/s2d',
            permission: PERMISSIONS.TRANSACTION,
          },
        ],
      },
      {
        key: 'invoiceGuide',
        label: 'Hướng Dẫn Sử Dụng',
        path: '/invoices/electronic-invoices/guide',
        permission: PERMISSIONS.E_INVOICE,
      },
    ],
  },
  {
    key: 'gdpos',
    label: 'Giao Diện POS',
    path: '/create-sale-order',
  },
];
